<template>
  <div class="details-container qtm-body text-dark-grey">
    <template v-for="detail in details" :key="detail.value">
      <slot :name="`detail.${detail.value}`" :detail="detail">
        <div :class="`text-${labelColor}`" v-text="detail.label" />
        <div :class="valueClass">
          <slot :name="detail.value" :text="detail.text">
            {{ detail.text }}
          </slot>
        </div>
      </slot>
    </template>
  </div>
</template>

<script setup lang="ts">
interface Detail {
  label: string
  text?: string
  value: string
}

export interface Props {
  details: Detail[]
  labelColor?: string
  labelSize?: string
  valueClass?: string
}

withDefaults(defineProps<Props>(), {
  labelColor: 'mid-grey',
  labelSize: '6em',
  valueClass: undefined,
})
</script>

<style scoped lang="scss">
.details-container {
  display: grid;
  align-items: start;
  gap: 8px;
  grid-template-columns: fit-content(v-bind(labelSize)) auto;
  grid-template-rows: auto;
}
</style>
